// /home/szymon/kreator2/frontend/src/components/TemplatesPanel.js
// v3.1.0 – Dodano przycisk "Eksport nr PDF" i funkcję handleExportPdfNumbers()

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function TemplatesPanel({ backendUrl }) {
  const navigate = useNavigate();

  const [collections, setCollections] = useState([]);
  const [error, setError] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [newCollName, setNewCollName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchCollections();
    // eslint-disable-next-line
  }, []);

  const fetchCollections = () => {
    fetch(`${backendUrl}/admin/templates`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Błąd pobierania listy szablonów.');
        }
        return res.json();
      })
      .then((data) => {
        setCollections(data);
        setError('');
      })
      .catch((err) => {
        console.error(err);
        setError('Nie udało się pobrać szablonów.');
      });
  };

  const handleAddCollection = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch(`${backendUrl}/admin/templates`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name: newCollName })
      });
      if (!response.ok) {
        throw new Error('Błąd tworzenia szablonu.');
      }
      setNewCollName('');
      setShowAddForm(false);
      fetchCollections();
    } catch (err) {
      console.error(err);
      setError('Nie udało się dodać szablonu.');
    }
  };

  // Filtrowanie
  const filtered = collections.filter((c) =>
    c.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Klik w wiersz => przechodzimy do szczegółów szablonu
  const handleRowClick = (collectionId) => {
    navigate(`/admin/templates/${collectionId}`);
  };

  // NOWA FUNKCJA: pobranie .txt z numerami pdf
  const handleExportPdfNumbers = async () => {
    try {
      const resp = await fetch(`${backendUrl}/admin/templates/export-pdf-numbers`, {
        credentials: 'include'
      });
      if (!resp.ok) {
        throw new Error('Błąd pobierania pliku .txt');
      }
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'pdfNumbers.txt';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('[TemplatesPanel] handleExportPdfNumbers =>', err);
      alert('Błąd podczas pobierania pliku .txt');
    }
  };

  return (
    <div className="orders-container">
      <h3>Lista Szablonów</h3>
      {error && <p className="dashboard-error">{error}</p>}

      <div className="orders-search">
        <label htmlFor="searchInput">Wyszukaj:</label>
        <input
          id="searchInput"
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Nazwa szablonu..."
          className="orders-input"
        />
      </div>

      <div style={{ marginBottom: 15 }}>
        <button
          className="orders-add-btn"
          onClick={() => setShowAddForm((prev) => !prev)}
        >
          {showAddForm ? 'Anuluj' : 'Dodaj szablon'}
        </button>

        {/* Nowy guzik do eksportu pdfNumbers */}
        <button
          className="orders-add-btn"
          style={{ marginLeft: 10 }}
          onClick={handleExportPdfNumbers}
        >
          Eksport nr PDF
        </button>
      </div>

      {showAddForm && (
        <form onSubmit={handleAddCollection} className="orders-add-form">
          <div className="orders-form-group">
            <label>Nazwa szablonu:</label>
            <input
              type="text"
              value={newCollName}
              onChange={(e) => setNewCollName(e.target.value)}
              required
              className="orders-input"
            />
          </div>
          <button type="submit" className="orders-button">
            Zapisz
          </button>
        </form>
      )}

      {filtered.length === 0 && !error ? (
        <p>Brak szablonów pasujących do wyszukiwania.</p>
      ) : (
        filtered.length > 0 && (
          <table className="orders-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nazwa</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((coll) => (
                <tr
                  key={coll.id}
                  onClick={() => handleRowClick(coll.id)}
                  className="orders-row"
                >
                  <td>{coll.id}</td>
                  <td>{coll.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}
    </div>
  );
}
